import { Box, Skeleton, Typography } from '@mui/material'

export const CategorySkeleton = () => {
    return (
        <>
            <Box width="100%" >
                <Typography component="div" className="w-100" variant="body1"><Skeleton /></Typography>
                <Typography component="div" className="w-100" variant="body1"><Skeleton /></Typography>
                <Typography component="div" className="w-100" variant="body1"><Skeleton /></Typography>
                <Typography component="div" className="w-100" variant="body1"><Skeleton /></Typography>
                <Typography component="div" className="w-100" variant="body1"><Skeleton /></Typography>
                <Typography component="div" className="w-100" variant="body1"><Skeleton /></Typography>
                <Typography component="div" className="w-100" variant="body1"><Skeleton /></Typography>
                <Typography component="div" className="w-100" variant="body1"><Skeleton /></Typography>
                <Typography component="div" className="w-100" variant="body1"><Skeleton /></Typography>
            </Box>
        </>
    )
}
